import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import ItemSearchResult from '../../models/ItemSearchResult';
import DataService from '../../services/data.service';
import { DataResult, SearchResult } from '../../types/Result';
import ItemRevisionCard from './Components/ItemRevisionCard';
import Unauthorized from './../Authentication/Unauthorized';
import ItemFilterForm, { ItemSearchCriteria } from './FilterForm/ItemFilterFormAdvanced';
import Item_popup_AddToProject from './Popups/Item_popup_AddToProject';
import Item_popup_DeleteItems from './Popups/Item_popup_DeleteItems';
import Item_popup_SalesPresentation from './Popups/Item_popup_SalesPresentation';
import { FormConfig, SelectListOption } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import NumberField from '../../components/Fields/NumberField';
import SelectListField from '../../components/Fields/SelectListField';
import NumberControl from '../../components/Fields/NumberControl';
import SelectListControl from '../../components/Fields/SelectListControl';
import Translate from '../../components/Translate';
import { Col, Container, Row } from 'reactstrap';
import Button from '../../components/Buttons/Button';

export interface PagingDetails {
    pageNumber: number
    pageSize: number
    sortBy: string
}

const ItemAdancedSearchView: React.FC = () => {
    const [items, setItems] = useState<ItemSearchResult[]>([]);
    const [pagingDetails, setPagingDetails] = useState<PagingDetails>();
    const [selectedItemIds, setSelectedItemIds] = useState<number[]>([]);
//    const [selectedItems, setSelectedItems] = useState<ItemSearchResult[]>([]);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [showMoreButton, setShowMoreButton] = useState<boolean>(false);

    const [showAddToProjectPopup, setShowAddToProjectPopup] = useState<boolean>(false);
    const [showDeleteItemsPopup, setShowDeleteItemsPopup] = useState<boolean>(false);
    const [showSalesPresentationPopup, setShowSalesPresentationPopup] = useState<boolean>(false);
    const [sortOptions] = useState<SelectListOption[]>([{ value: "CreatedOn", label: "Create date" }, { value: "Item_ItemNr", label: "Item Nr" }])

    const navigate = useNavigate();
    const { handleResult, handleException } = useNotifications();

    useEffect(() => {
        setPagingDetails({ pageNumber: 1, pageSize: 100, sortBy: 'CreatedOn' });
        const filterItem = localStorage.getItem("itemFilterFormAdvanced");
        if (filterItem !== null) {
            let filter: ItemSearchCriteria = JSON.parse(filterItem);
            if (filter.pageSize && filter.pageNumber)
                setPagingDetails({ pageNumber: 1, pageSize: filter.pageSize, sortBy: filter.sortBy});
        }

        const selectedItemIdsFromStorage = localStorage.getItem("selectedItemIds");
        if (selectedItemIdsFromStorage)
            setSelectedItemIds(selectedItemIdsFromStorage.split(',').map(x => Number(x)))

    },[])

    function search(criteria: ItemSearchCriteria): void {
        setShowSpinner(true);
        DataService
            .post<SearchResult<ItemSearchResult[]>>(`api/v1/ItemRevisions/Search/`, criteria)
            .then(response => {
                setShowSpinner(false);
                handleResult(response);
                if (response.isSuccesful === true && response.data) {

                    for (var j = 0; j < selectedItemIds.length; j++) {
                        for (var i = 0; i < response.data.length; i++) {
                            if (response.data[i].itemRevisionId == selectedItemIds[j]) {
                                response.data[i].selected = true
                                //selectedItems.push(response.data[i])
                            }
                        }
                    }

                    //setSelectedItems(x => [...selectedItems])

                    if (pagingDetails) {
                        pagingDetails.pageNumber = response.pageNumber
                        setPagingDetails(pagingDetails)
                    }

                    setShowMoreButton(response.pageNumber < response.pageCount)

                    if (criteria.pageNumber == 1)
                        setItems(response.data);
                    else
                        setItems([...items, ...response.data])

                    if (criteria.pageNumber == 1 && response.data.length === 1)
                        itemClicked(response.data[0]);
                }
            })
            .catch(e => {
                setShowSpinner(false);
                handleException(e)
            });
    }

    const { isAuthorizedForItemType } = useAuth();
    if (!isAuthorizedForItemType(ApplicationFunctions.SearchItemRevisionAdvanced)) {
        return (<Unauthorized />);
    }

    let results = items.map((item, index) => {
        return <ItemRevisionCard itemRevision={item} handleItemClicked={itemClicked} handleItemSelected={itemSelected} index={index} key={index} />
    });

    function itemSelected(index) {
        const item = items[index];
        item.selected = !item.selected;

        setItems(x => [...items]);

        if (item.selected == true)
            selectedItemIds.push(item.itemRevisionId)
            //setSelectedItems(x => [...selectedItems, item])
        else
            selectedItemIds.slice(selectedItemIds.indexOf(item.itemRevisionId), 1)
            //setSelectedItems(x => [...selectedItems.filter(y => y.itemRevisionId != item.itemRevisionId)])

        setSelectedItemIds(x => selectedItemIds)
        localStorage.setItem(`selectedItemIds`, selectedItemIds.join());
    }

    function selectAll() {
        items.forEach((item) => {
            if (item.selected != true)
                selectedItemIds.push(item.itemRevisionId)
                //selectedItems.push(item)

            item.selected = true
        })
        setItems(x => [...items])
        //setSelectedItems(x => [...selectedItems])

        setSelectedItemIds(x => selectedItemIds)
        localStorage.setItem(`selectedItemIds`, selectedItemIds.join());

        //var selectedItemIds = items.filter(x => x.selected == true).map(x => x.itemRevisionId).join(',');
        //localStorage.setItem(`selectedItemIds`, selectedItemIds);
    }

    function clearSelection()
    {
        items.forEach((item) => {
            item.selected = false
        })
        setItems(x => [...items])

        setSelectedItemIds(x => [])
        localStorage.setItem(`selectedItemIds`, '');
    }


    function addToProject() {
        setShowAddToProjectPopup(true)
    }

    function deleteItems() {
        setShowDeleteItemsPopup(true)
    }

    function removeDeletedItems(itemRevisionIds: number[]) {
        setItems(items.filter(item => itemRevisionIds.includes(item.itemRevisionId) === false))
    }

    function generateSalesPresentation() {
        setShowSalesPresentationPopup(true)
    }

    function itemClicked(itemRevision: ItemSearchResult) {
        let url = '/plm/Items/ItemRevision/' + itemRevision.itemRevisionId;
        let navigateTitle = itemRevision.itemNr + ' v' + itemRevision.revisionNumber;
        window.open(url, '_blank')//, 'rel=noopener noreferrer')
        //navigate(url, { state: { title: navigateTitle, fromMenu: false } });
    }

    function moreClicked() {
        if (pagingDetails) {
            pagingDetails.pageNumber += 1;
            setPagingDetails({...pagingDetails})
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'pageSize', label: 'Nr of items', labelSize: 3 },
            { name: 'sortBy', label: 'Order by', labelSize: 3 },
        ],
        showErrors: 'always',
        handleSubmit: () => { },
    };

    const { getFieldProps } = useValidation(formConfig, pagingDetails);

    return (
        <div className='main-content'>
            <ItemFilterForm pagingDetails={pagingDetails} handleSearch={search} handleAddToProject={addToProject} handleDeleteItems={deleteItems} handleSalesPresentation={generateSalesPresentation} handleSelectAll={selectAll} handleClearSelection={clearSelection} forBom={false} />
            <Container fluid>
                <Row>
                    <Col md='6'>
                        <NumberField {...getFieldProps('pageSize')} />
                    </Col>
                    <Col md='6'>
                        <SelectListField {...getFieldProps('sortBy')} options={sortOptions} />
                    </Col>
                </Row>
            </Container>
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                {results}
            </div>
            {showMoreButton && (
                <Container fluid>
                    <Row><Col md='12'><div style={{ textAlign: 'center' }}><Button text='More' onClick={moreClicked} /></div></Col></Row>
                </Container>
            )}

            {showAddToProjectPopup && <Item_popup_AddToProject show={showAddToProjectPopup} selectedItems={items.filter((item) => item.selected === true)} onHide={(projectId?: number) => {
                    setShowAddToProjectPopup(false);
                    if (projectId && projectId > 0)
                        navigate('/plm/Projects/Details/' + projectId)
                }} />
            }
            {showSalesPresentationPopup && <Item_popup_SalesPresentation show={showSalesPresentationPopup} selectedItemIds={selectedItemIds} onHide={() => { setShowSalesPresentationPopup(false); }} />}
            {showDeleteItemsPopup && <Item_popup_DeleteItems show={showDeleteItemsPopup} onHide={() => setShowDeleteItemsPopup(false)} onDelete={removeDeletedItems} selectedItems={items.filter(item => item.selected === true)} />}
            {showSpinner && (<SpinnerOverlay />)}
        </div>
    );
}
export default ItemAdancedSearchView;

